// Author Liang Gang Qiang
// Date 2021-09-09 16:42:36

class EmAdmRoleTag {
constructor({
        id = null,
        roleId = '',
        roleTagCode = '',
        roleLevel = '',
        roleAdditionalCodeA = '',
        roleAdditionalCodeB = '',
        roleAdditionalCodeC = '',
        remark = ''}
= {}) {
    this.id = id;
    this.roleId = roleId;
    this.roleTagCode = roleTagCode;
    this.roleLevel = roleLevel;
    this.roleAdditionalCodeA = roleAdditionalCodeA;
    this.roleAdditionalCodeB = roleAdditionalCodeB;
    this.roleAdditionalCodeC = roleAdditionalCodeC;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmRoleTag();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAdmRoleTag.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleId',
        label: 'label.em.admin.emAdmRoleTag.grid.roleId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleName',
        label: 'label.em.admin.emAdmRoleTag.grid.roleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleTagCode',
        label: 'label.em.admin.emAdmRoleTag.grid.roleTagCode',
        sortable: true,
        form: {
        type: 'select'
        }
        },
        {
        key: 'roleLevel',
        label: 'label.em.admin.emAdmRoleTag.grid.roleLevel',
        sortable: true,
        form: {
        type: 'select'
        }
        },
        {
        key: 'roleAdditionalCodeA',
        label: 'label.em.admin.emAdmRoleTag.grid.roleAdditionalCodeA',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleAdditionalCodeB',
        label: 'label.em.admin.emAdmRoleTag.grid.roleAdditionalCodeB',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleAdditionalCodeC',
        label: 'label.em.admin.emAdmRoleTag.grid.roleAdditionalCodeC',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmRoleTag.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    roleIdFilter : "",
    roleTagCodeFilter : "",
    roleLevelFilter : "",
    roleAdditionalCodeAFilter : "",
    roleAdditionalCodeBFilter : "",
    roleAdditionalCodeCFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'roleIdFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleTagCodeFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleTagCode',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'roleLevelFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleLevel',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'roleAdditionalCodeAFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleAdditionalCodeA',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleAdditionalCodeBFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleAdditionalCodeB',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleAdditionalCodeCFilter',
        label: 'label.em.admin.emAdmRoleTag.filter.roleAdditionalCodeC',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'roleId',
        label: 'label.em.admin.emAdmRoleTag.entity.roleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleTagCode',
        label: 'label.em.admin.emAdmRoleTag.entity.roleTagCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'roleLevel',
        label: 'label.em.admin.emAdmRoleTag.entity.roleLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'roleAdditionalCodeA',
        label: 'label.em.admin.emAdmRoleTag.entity.roleAdditionalCodeA',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleAdditionalCodeB',
        label: 'label.em.admin.emAdmRoleTag.entity.roleAdditionalCodeB',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleAdditionalCodeC',
        label: 'label.em.admin.emAdmRoleTag.entity.roleAdditionalCodeC',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmRoleTag.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmRoleTag, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
